document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var burger = document.querySelector('[data-mobile-nav-open]');
  var closeBtn = document.querySelector('[data-mobile-nav-close]');
  var backdrop = document.querySelector('[data-mobile-nav-backdrop]');
  var nav = document.querySelector('[data-mobile-nav]');

  function openNav() {
    if (nav) nav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (nav) nav.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openNav);
  if (closeBtn) closeBtn.addEventListener('click', closeNav);
  if (backdrop) backdrop.addEventListener('click', closeNav);

  // Quantity steppers on product form
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      input.value = Math.max(1, v - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      input.value = v + 1;
    });
  });

  // Newsletter form (theme section) — prevent default if action not set
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) {
        e.preventDefault();
        input.reportValidity();
      }
    });
  });
});
